import React from "react";
import "../components/css/Terms.css"; // Path to your CSS
import TermsCom from "../components/TermsCom";
const Terms = () => {
  return (
    // This parent div ensures the dark theme for the iframe
    <div className="terms-page">
      <div className="terms-wrapper">
         <div className="terms-container">
          <h1 className="terms-title">Terms of Use</h1>
          <TermsCom />

         </div>
      </div>
    </div>
  );
};

export default Terms;